import { IoExpand, IoContract } from 'react-icons/io5';
import { useFullscreen } from '@/hooks/useFullscreen';

interface FullscreenButtonProps {
  className?: string;
}

export const FullscreenButton = ({ className = '' }: FullscreenButtonProps) => {
  const { isFullscreen, isFullscreenSupported, toggleFullscreen } =
    useFullscreen();

  if (!isFullscreenSupported) {
    return null;
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleFullscreen();
    }
  };

  return (
    <button
      onClick={toggleFullscreen}
      onKeyDown={handleKeyDown}
      className={`flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200 hover:bg-[#ededed] dark:hover:bg-[#282828] ${className}`}
      title={isFullscreen ? 'Quitter le mode plein écran' : 'Mode plein écran'}
      data-tooltip-content={
        isFullscreen ? 'Quitter le mode plein écran' : 'Mode plein écran'
      }
      data-tooltip-id="tooltip"
      data-tooltip-place="bottom"
      data-tooltip-delay-show={100}
      data-tooltip-offset={5}
    >
      {isFullscreen ? (
        <IoContract className="text-lg text-neutralText dark:text-neutralText-dark" />
      ) : (
        <IoExpand className="text-lg text-neutralText dark:text-neutralText-dark" />
      )}
    </button>
  );
};
